import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTitleCase]'
})
export class TitleCaseDirective {
  constructor(@Optional() private control: NgControl) {}

  @HostListener('blur')
  onBlur(): void {
    if (!this.control?.control) return;

    const original = this.control.control.value;
    const transformed = this.toTitleCase(original);

    if (original !== transformed) {
      this.control.control.setValue(transformed, { emitEvent: false });
    }
  }

  private toTitleCase(text: string): string {
    if (typeof text !== 'string') return text;
    return text
      .trim()
      .toLowerCase()
      .replace(/(?:^|\s|[-'])\S/g, match => match.toUpperCase());
  }
}
